import type { AccessibleEntity, EntityAccessEntity } from "~/src/api";
import { type AuthFunction, toUnordered } from "~/utils/tanstack/global";
import { queryOptions } from "@tanstack/vue-query";
import { checkEntityAccess } from "~/src/gating";
import { useCacheTimings } from "~/composables/cacheTiming";

export const useGatingAccess = (
  ids: MaybeRef<string[]>,
  entityType: AccessibleEntity["type"],
  auth?: AuthFunction,
) => {
  const params = computed(() => {
    const unorderedIds = toUnordered("ids", unref(ids));
    return {
      ...unorderedIds,
      authed: !!auth || undefined,
    };
  });

  return queryOptions({
    queryKey: ["entity_access_map", "entity", params],
    queryFn: async () => {
      if (unref(ids).length === 1 && unref(ids)[0] === "unknown")
        throw new Error("Chapter Unknown");
      if (!unref(ids).length)
        return {
          id: "",
          type: "entity_access_map",
          attributes: { map: {} },
        } as EntityAccessEntity;

      return await checkEntityAccess(
        unref(ids).map((id) => ({
          entityId: id,
          entityType,
        })),
        (await auth?.()) || undefined,
      );
    },
    select: (data) => data.attributes.map,
    staleTime: useCacheTimings().entity.entity_access_map,
  });
};
